import { useContext } from "react";
import {
  SessionContext,
  type SessionContextValue,
} from "@/contexts/SessionContext";

/**
 * useSession hook - Access session data and auth state
 *
 * Returns:
 * - data: The current session (user info, expires, etc.) or null
 * - status: "loading" | "authenticated" | "unauthenticated"
 * - isAuthEnabled: Whether authentication is enabled in the app
 * - update: Function to manually refresh the session
 */
export function useSession(): SessionContextValue {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
}
